/*
eslint no-shadow: ["error", { "allow": ["state"] }]
*/
import jwtDecode from 'jwt-decode';

const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  permissions: localStorage.getItem('permissions') || '',
  customerId: localStorage.getItem('customerId') || '',
  customerCode: localStorage.getItem('customerCode') || '',
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, payload) {
    state.status = 'success';
    state.token = payload.token;
    state.permissions = payload.roles;
    state.customerId = typeof payload.customerId === 'number' ? payload.customerId.toString() : payload.customerId;
    state.customerCode = typeof payload.customerCode === 'string' ? payload.customerCode.toString() : payload.customerCode;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.permissions = '';
  },
};

const actions = {
  login({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const { email } = payload;
      const { password } = payload;
      const { axios } = payload;
      commit('auth_request');
      axios({
        url: '/api/login',
        data: { email, password },
        method: 'POST',
        withCredentials: true, // allow browser to accept Set-Cookie from API (cross-origin)
      })
        .then((resp) => {
          if (resp.data !== '') {
            const { token } = resp.data;
            const decoded = jwtDecode(resp.data.token);
            const { roles, customerId, customerCode } = decoded;
            if (typeof roles === 'undefined' || roles.length === 0) {
              commit('auth_error');
              dispatch('logout', { axios });
              return;
            }
            localStorage.setItem('token', token);
            localStorage.setItem('permissions', roles);
            localStorage.setItem('customerId', customerId);
            localStorage.setItem('customerCode', customerCode);
            axios.defaults.headers.Authorization = `Bearer ${token}`;
            commit('auth_success', {
              token, roles, customerId, customerCode,
            });
            resolve(resp);
          } else {
            dispatch('logout', { axios });
          }
        })
        .catch((err) => {
          commit('auth_error');
          localStorage.removeItem('token');
          localStorage.removeItem('permissions');
          localStorage.removeItem('customerId');
          localStorage.removeItem('customerCode');
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('logout');
      localStorage.removeItem('token');
      localStorage.removeItem('permissions');
      localStorage.removeItem('customerId');
      localStorage.removeItem('customerCode');
      resolve();
    });
  },
  losted_auth({ dispatch }, { axios, error }) {
    if (error.response.status === 401 || error.response.status === 403) {
      dispatch('logout', { axios });
    }
  },
};

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  isSuperuser: state => state.permissions.includes('ROLE_SUPER_ADMIN'),
  customerId: state => state.customerId,
  customerCode: state => state.customerCode,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
